import jwtDecode from 'jwt-decode'

import Storage, { TOKEN_KEY, FIREBASE_TOKEN_KEY } from '~/services/storage.service'

class AuthService {
  public setSession = (tokens: { accessToken: string; firebaseToken: string } | null): void => {
    if (tokens) {
      Storage.setItem(TOKEN_KEY, tokens.accessToken)
      Storage.setItem(FIREBASE_TOKEN_KEY, tokens.firebaseToken)
    } else {
      Storage.removeItem(TOKEN_KEY)
      Storage.removeItem(FIREBASE_TOKEN_KEY)
    }
  }

  public setFirebaseToken = (firebaseToken: string | null): void => {
    if (firebaseToken) {
      Storage.setItem(FIREBASE_TOKEN_KEY, firebaseToken)
    } else {
      Storage.removeItem(FIREBASE_TOKEN_KEY)
    }
  }

  public getAccessToken(): string | null {
    return Storage.getItem(TOKEN_KEY) ?? null
  }

  public getFirebaseToken(): string | null {
    return Storage.getItem(FIREBASE_TOKEN_KEY) ?? null
  }

  public getTokens(): { accessToken: string | null; firebaseToken: string | null } {
    return {
      accessToken: this.getAccessToken(),
      firebaseToken: this.getFirebaseToken(),
    }
  }

  public getUserId(): number | undefined {
    const token = this.getAccessToken()
    const decoded = token ? jwtDecode(token) : null
    return decoded?.id
  }

  public isAuthenticated(): boolean {
    return !!this.getAccessToken()
  }

  public setRedirectTo(redirectTo?: string): void {
    if (redirectTo) {
      sessionStorage.setItem('redirectTo', JSON.stringify(redirectTo))
    } else {
      sessionStorage.removeItem('redirectTo')
    }
  }

  public getRedirectTo(): string | undefined {
    const redirectTo = sessionStorage.getItem('redirectTo')
    return redirectTo && redirectTo.length > 0 ? JSON.parse(redirectTo) : undefined
  }
}

const authService = new AuthService()
export default authService
